import { Insurance } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface InsuranceResponse extends DefaultResponse<Insurance, true> {}
interface InsuranceSingleResponse extends DefaultResponse<Insurance, false> {}

export const insuranceService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<InsuranceResponse>("/insurance", {
      params: {
        page,
        per_page,
        search,
        ...filters,
      },
    });
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<InsuranceSingleResponse>(`/insurance/${id}`);
    return response.data;
  },

  async store(data: Partial<Insurance>) {
    const response = await api.post<InsuranceSingleResponse>(
      "/insurance",
      data,
    );
    return response.data;
  },

  async update(id: string | number, data: Partial<Insurance>) {
    const response = await api.put<InsuranceSingleResponse>(
      `/insurance/${id}`,
      data,
    );
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete<DefaultResponse<never>>(
      `/insurance/${id}`,
    );
    return response.data;
  },

  async setPaymentDate(id: number, paymentDate: string) {
    const response = await api.put<DefaultResponse<never>>(
      `/insurance/${id}/pay`,
      {
        payment_date: paymentDate,
      },
    );
    return response.data;
  },
};
